/**
 * Resolve the user's BCP 47 locale tag from `navigator.language`.
 *
 * Returns the navigator value normalized (lowercase language, uppercase
 * region). Consumers downstream of this resolver handle locale-specific
 * concerns individually: `Intl.NumberFormat` accepts any tag and moment
 * falls back to its base 'en' locale when it doesn't have data for the tag.
 *
 * Falls back to en-US only when `navigator.language` is unparseable.
 */
function detectDeviceLocale() {
  const tag = window.navigator.language;

  if (!tag || typeof tag !== 'string') {
    return 'en-US';
  }

  const [lang, region] = tag.split('-');

  if (!lang) {
    return 'en-US';
  }

  if (!region) {
    return lang.toLowerCase();
  }

  return `${lang.toLowerCase()}-${region.toUpperCase()}`;
}



export default detectDeviceLocale;
